import React from 'react'
import { fontFamilies } from '@fedsim/constants'
import { BORDERRADIUS as borderRadius } from "@fedsim/constants"

import { Button } from '@mui/material'

import { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles'
export const GameButton = styled((props: ButtonProps) => <Button {...props} />)(() => ({
    fontFamily: fontFamilies.buttonFont,
    textTransform: 'none',
    borderRadius
}))

export default GameButton